import api from './api';

/**
 * Servicio para gestionar áreas curriculares
 */
export const areasService = {
  /**
   * Obtiene todas las áreas del currículo nacional
   * @returns {Promise<Array>} Lista de áreas
   */
  getAll: async () => {
    try {
      const response = await api.get('/areas');
      return response.data || [];
    } catch (error) {
      console.error('Error al obtener áreas:', error);
      throw error;
    }
  },

  /**
   * Obtiene un área específica por ID
   * @param {number} id - ID del área
   * @returns {Promise<Object>} Datos del área
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/areas/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener área ${id}:`, error);
      throw error;
    }
  },
};

export default areasService;
